import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { Typography } from '@mui/material';

export type t_radioButtonValue = {
	name: string;
	value: string;
	invisible?: boolean;
};

export type P_RadioButtonsForEdit = P_RadioButtonsForEditBase & {
	id: string;
	label?: string;
	row?: boolean;
};
export type P_RadioButtonsForEditBase = {
	items: t_radioButtonValue[];
	onChange: (value: number) => any;
	selectedItemIndex: number;
};

export default function RadioButtonsForEdit(props: P_RadioButtonsForEdit) {
	const _onChange = React.useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) =>
			props.onChange(Number(event.target.value)),
		[],
	);

	const selectedItemIndex = String(props.selectedItemIndex);
	const labelId = props.id + '-label';
	return (
		<FormControl>
			{props.label && (
				<FormLabel id={labelId} sx={{ fontSize: 11.5 }}>
					{props.label}
				</FormLabel>
			)}
			<RadioGroup
				aria-labelledby={labelId}
				value={selectedItemIndex}
				name={props.id}
				onChange={_onChange}
				row={props.row}
			>
				{props.items.map((e, i) => {
					const style = e.invisible ? { display: 'none' } : undefined;
					return (
						<FormControlLabel
							key={i}
							value={i}
							style={style}
							control={<Radio size='small' />}
							label={<Typography variant='body2'>{e.name}</Typography>}
						/>
					);
				})}
			</RadioGroup>
		</FormControl>
	);
}
